import { motion } from "framer-motion";

export function HoverLink({ label }) {
  const text = typeof label === "object" && label?.name != null ? label.name : label;
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      animate="rest"
      className="relative cursor-pointer"
    >
      <motion.span
        variants={{
          rest: { y: 0, color: "#000929" },
          hover: { y: -1, color: "#2563eb" },
        }}
        transition={{ duration: 0.2, ease: "easeOut" }}
      >
        {text}
      </motion.span>

      <motion.div
        variants={{
          rest: { opacity: 0, y: 4, scaleX: 0 },
          hover: { opacity: 1, y: 0, scaleX: 1 },
        }}
        transition={{ duration: 0.25, ease: "easeOut" }}
        className="absolute left-0 -bottom-1 h-[2px] w-full bg-[#097FE6] origin-left rounded-full"
      />
    </motion.div>
  );
}
